import React from 'react';
import { Section, ContentFormatter, Heading, Copy, ImageGrid } from '@belong/ui-components';
import { ISectionImageGrid } from './model';

const SectionImageGrid: React.FC<ISectionImageGrid> = ({
  id,
  anchorName,
  description,
  heading,
  identifier,
  images,
  sectionStyles
}: ISectionImageGrid) => {
  return (
    <Section
      data-contentid={id}
      data-identifier={identifier}
      data-testid="section-image-grid"
      id={anchorName}
      {...sectionStyles}
    >
      <ContentFormatter alignment="center">
        <Heading as="h2">{heading}</Heading>
        <Copy variant="large">{description}</Copy>
      </ContentFormatter>

      <ImageGrid
        images={images.map(({ source, alt, src = '' }) => ({
          source: source || src,
          alt
        }))}
      />
    </Section>
  );
};

export default SectionImageGrid;
